import type { FC, ReactElement } from "react";
import { useMemo } from "react";

import {
    FiltersChipOperatorItem,
    FiltersComplexChip,
} from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IAppsAdSellersFilterItem } from "app/pages/sales-intelligence/store/find-apps/types";

type InclusionAdsSellersChipProps = {
    item: IAppsAdSellersFilterItem;
    onEdit: (item: IAppsAdSellersFilterItem) => void;
    onDelete: (item: IAppsAdSellersFilterItem) => void;
};

const InclusionAdsSellersChip: FC<InclusionAdsSellersChipProps> = ({ item, onEdit, onDelete }): ReactElement => {
    const renderContent = useMemo((): ReactElement[] => {
        return item.adsSellerDomainNames.map((domain: string, i: number) => {
            return (
                <FiltersChipOperatorItem
                    key={domain}
                    itemTitle={domain}
                    operator={i > 0 ? item.operator : undefined}
                />
            );
        });
    }, [item]);

    return (
        <FiltersComplexChip
            title={{ key: `si.common.inclusions.${item.inclusion}` }}
            onActionClick={() => onEdit(item)}
            onRemove={() => onDelete(item)}
        >
            {renderContent}
        </FiltersComplexChip>
    );
};

export default InclusionAdsSellersChip;
